import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import useWorkshopVerificationRequestQuery from 'hooks/useWorkshopVerificationRequestQuery';

async function updateDocs(
  axios: AxiosInstance,
  workshopVerificationId: number | undefined,
  params: {
    identification_valid?: boolean;
    identification_errors?: string[];
    business_licence_valid?: boolean;
    business_licence_errors?: string[];
    power_of_attorney_valid?: boolean;
    power_of_attorney_errors?: string[];
    power_of_attorney_uuid?: string;
    handwerkskarte_valid?: boolean;
    handwerkskarte_errors?: string[];
    handwerkskarte_uuid?: string;
    identification_uuid?: string;
    business_licence_uuid?: string;
    files_update_reason?: string;
  },
): Promise<object> {
  const { data } = await axios.put(`${config.apiBaseUrl}/op/v2/workshop-verification-request/${workshopVerificationId}/update-documents`, params);
  return data;
}

export default function useUpdateWorkshopVerificationDocsMutation(workshopVerificationId: number | undefined) {
  const queryClient = useQueryClient();
  const axios = useAxios();
  const toast = useToast();

  return useMutation({
    mutationFn: (params: {
      identification_valid?: boolean;
      identification_errors?: string[];
      business_licence_valid?: boolean;
      business_licence_errors?: string[];
      power_of_attorney_valid?: boolean;
      power_of_attorney_errors?: string[];
      power_of_attorney_uuid?: string;
      handwerkskarte_valid?: boolean;
      handwerkskarte_errors?: string[];
      handwerkskarte_uuid?: string;
      identification_uuid?: string;
      business_licence_uuid?: string;
      files_update_reason?: string;
    }) => updateDocs(axios, workshopVerificationId, params),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: useWorkshopVerificationRequestQuery.getKey(workshopVerificationId),
      });
    },
    onError: (error: any) => {
      manageErrorResponse(toast, error.response.data);
    },
  });
}
